import { observer } from 'mobx-react';
import * as React from 'react';
import ModalStore from '../../../../../Modal/Store';
import LearningCollectionEditStore from '../../Store';
import { Previewing, PreviewingUpdating, previewShaHashGenerator } from '../../Store/Types';
import BackButton from '../../../LearningCollectionSteps/BackButton';
import ContinueButton from '../../../LearningCollectionSteps/ContinueButton';
import Navigation from '../Navigation';
import Header from './Header';
import IframeContent from './IframeContent';
import IframeContentStore from './IframeContent/Store';
import LearningCollectionDescription from './LearningCollectionDescription';
import LeaveEditMode from './LeaveEditMode';
import SideBar from './SideBar';
import PreviewStore from './Store';

interface Props {
  store: LearningCollectionEditStore;
  state: Previewing | PreviewingUpdating;
}

class Preview extends React.Component<Props> {
  previewStore: PreviewStore = new PreviewStore(
    this.props.store,
    previewShaHashGenerator(this.props.state),
  );

  leaveEditModeModalStore: ModalStore = new ModalStore();
  learningCollectionDescriptionModalStore: ModalStore = new ModalStore();
  iframeContentStore: IframeContentStore = new IframeContentStore(this.props.store.links);

  componentDidMount() {
    this.iframeContentStore.ready();
  }

  render() {
    return (
      <>
        <div>
          <Navigation store={this.props.store}>
            <BackButton handleOnClick={this.props.store.building} />
            <ContinueButton
              handleOnClick={() => {
                if (this.previewStore.inEditMode && this.previewStore.unsavedChanges) {
                  this.leaveEditModeModalStore.open();
                } else {
                  this.props.store.sharing();
                }
              }}
              disabled={this.previewStore.inEditMode}
            />
          </Navigation>
          <div className="bg-white pt-14">
            <div className="mx-auto flex h-[83vh] max-w-clientPortalMaxWidth px-2.5 lg:px-12">
              <div className="h-full grow">
                <Header
                  store={this.previewStore}
                  leaveEditModeModalStore={this.leaveEditModeModalStore}
                />
                <IframeContent store={this.iframeContentStore} />
              </div>
              <SideBar
                store={this.previewStore}
                learningCollectionDescriptionModalStore={
                  this.learningCollectionDescriptionModalStore
                }
                iframeContentStore={this.iframeContentStore}
              />
            </div>
          </div>
        </div>
        <LeaveEditMode
          previewStore={this.previewStore}
          modalStore={this.leaveEditModeModalStore}
          iframeContentStore={this.iframeContentStore}
        />
        <LearningCollectionDescription
          previewStore={this.previewStore}
          modalStore={this.learningCollectionDescriptionModalStore}
        />
      </>
    );
  }
}

export default observer(Preview);
